import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { LearnMoreLink } from '@bingads-webui-campaign-react/help';
import { MessageBar, MessageBarType } from '@bingads-webui-react/fabric-control';
import {
  recommendationInProductUpdateConfigs,
} from '@bingads-webui-campaign/recommendation-core';

export class WarnNotificationBanner extends React.PureComponent {
  static propTypes = {
    type: PropTypes.string.isRequired,
    preferencesService: PropTypes.objectOf(PropTypes.any),
    newI18n: PropTypes.PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    cid: PropTypes.number.isRequired,
    uid: PropTypes.number.isRequired,
    aid: PropTypes.number.isRequired,
    isMCC: PropTypes.bool.isRequired,
    dataService: PropTypes.shape({
      setAutoApplyOptInStatus: PropTypes.func.isRequired,
    }).isRequired,
    initializeMiniGrid: PropTypes.func,
    isFromSummary: PropTypes.bool,
    isAutoApplyOptIn: PropTypes.bool,
  };

  static defaultProps = {
    preferencesService: null,
    isFromSummary: false,
    initializeMiniGrid: _.noop,
    isAutoApplyOptIn: false,
  };

  componentDidMount() {
    const {
      isFromSummary,
      initializeMiniGrid,
    } = this.props;

    if (isFromSummary) {
      initializeMiniGrid();
    }
  }

  render() {
    const {
      type, preferencesService, newI18n, cid, aid, uid, isMCC, isAutoApplyOptIn,
    } = this.props;
    const config = recommendationInProductUpdateConfigs[type];

    return (
      <div className="summary-notification">
        { preferencesService && config &&
          config.warnNotification &&
          (config.warnNotificationInMCC === true ||
            (config.warnNotificationInMCC !== true && !isMCC)) && !isAutoApplyOptIn &&
            <div className="recommendation-notification-warning-container">
              <MessageBar
                messageBarType={MessageBarType.severeWarning}
                delayedRender={false}
              >
                <span
                // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{
                  __html: newI18n.getString(config.warnNotification)
                    .replace('{0}', uid)
                    .replace('{1}', cid)
                    .replace('{2}', aid),
                }}
                />
                {config.warnHelpInfo &&
                  <LearnMoreLink
                    topic={config.warnHelpInfo}
                    linkText={newI18n.getString(_TL_('Learn More'))}
                  />
                }
              </MessageBar>
            </div>
        }
      </div>
    );
  }
}
